module.exports = __webpack_public_path__ + "static/media/14.66ae19f5.png";